/** A photo the tech marked up (BL-025): the marked-up copy shows; the original is one tap away. */
export function MarkedUp({ p }: { p: { annotated: boolean; originalUrl: string | null } }) {
  if (!p.annotated) return null;
  return (
    <span className="row small">
      <span className="chip">Marked up</span>
      {p.originalUrl ? (
        <a href={p.originalUrl} target="_blank" rel="noreferrer">
          See the original
        </a>
      ) : null}
    </span>
  );
}
